webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  data: function data() {
    return {
      title: 'Agile Roadmap',
      state: {
        drawerOpen: true,
        velocityOpen: true
      },
      options: {
        sprintLength: 3,
        shirtSizes: ['XS', 'SM', 'MD', 'LG', 'XL'],
        velocities: [{ value: 1, shirt: 'XS', sprints: 0.5, width: '10rem' }, { value: 2, shirt: 'SM', sprints: 1, width: '13rem' }, { value: 3, shirt: 'MD', sprints: 2, width: '16rem' }, { value: 4, shirt: 'LG', sprints: 3, width: '19rem' }, { value: 5, shirt: 'XL', sprints: 4, width: '21rem' }],
        sizeCardWidth: true
      },
      roadmap: [{
        groupName: "R1",
        features: [{ name: "Infrastructure", size: 2, completed: true }, { name: "User Accounts", size: 2, completed: true }, { name: "Permissions", size: 2, completed: true }, { name: "User Profile", size: 2, completed: true }, { name: "Agency Profile", size: 2, completed: true }]
      }, {
        groupName: "Process",
        features: [{ name: "Referral", size: 2, completed: false }, { name: "Intake", size: 2, completed: false }]
      }, {
        groupName: "Client",
        features: [{ name: "Client Profile", size: 2, completed: false }, { name: "Consents", size: 2, completed: false }, { name: "Resources", size: 2, completed: false }, { name: "Health & Well Being", size: 2, completed: false }, { name: "Screenings", size: 2, completed: false }, { name: "Post Partum", size: 2, completed: false }, { name: "Financials", size: 2, completed: false }, { name: "Education", size: 2, completed: false }, { name: "Insurance", size: 2, completed: false }]
      }]
    };
  },
  computed: {
    allFeatures: function allFeatures() {
      var arrays = this.roadmap.map(function (grp) {
        return grp.features;
      });
      arrays = arrays.reduce(function (a, b) {
        return a.concat(b);
      }, []);
      return arrays;
    },
    completedFeatures: function completedFeatures() {
      return this.allFeatures.filter(function (ft) {
        return ft.completed;
      });
    },
    remainingFeatures: function remainingFeatures() {
      return this.allFeatures.filter(function (ft) {
        return !ft.completed;
      });
    },
    progress: function progress() {
      var allPoints = this.getSprints(this.allFeatures, this.options.velocities);
      var comPoints = this.getSprints(this.completedFeatures, this.options.velocities);
      return comPoints / allPoints * 100;
    },
    remainingTasks: function remainingTasks() {
      return "this.tasks.length - this.completedTasks";
    }
  },
  watch: {
    $data: {
      handler: function handler() {
        localStorage.setItem("roadmap", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.roadmap));
        localStorage.setItem("options", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.options));
      },
      deep: true
    }
  },

  filters: {
    timespan: function timespan(value) {
      var output = [];
      var valueInt = Math.round(+value);
      if (value === 0) return "Nothing";
      // get years
      if (valueInt > 52) {
        var years = Math.round(valueInt / 52);
        valueInt = valueInt % 52; // only store remainder
        output.push(pluralize(years, "year"));
      }
      // get months
      if (valueInt > 4) {
        var months = Math.round(valueInt / 4);
        valueInt = valueInt % 4; // only store remainder
        output.push(pluralize(months, "month"));
      }
      if (valueInt > 0) {
        output.push(pluralize(valueInt, "week"));
      }

      return output.join(", ");
    },

    shortTimespan: function shortTimespan(value) {
      return pluralize(Math.round(+value), "wk");
    }
  },
  methods: {},
  mounted: function mounted() {
    // restore value if we got from url
    if (window.location.hash) {
      var hash = window.location.hash.substring(1);
      var value = decodeURIComponent(hash);
      localStorage.setItem("roadmap", value);

      // wipe hash so it's prettier
      if (history.pushState) {
        history.pushState(null, null, "#");
      } else {
        window.location.hash = "#";
      }
    }
    // fetch from local storage
    var localRoadmap = localStorage.getItem("roadmap");
    if (localRoadmap) this.roadmap = JSON.parse(localRoadmap);

    var localOptions = localStorage.getItem("options");
    if (localOptions) this.options = JSON.parse(localOptions);

    console.log("App mounted!");
  }
});

function pluralize(value, unit) {
  if (value === 1) {
    return value + " " + unit;
  } else {
    return value + " " + unit + "s";
  }
}

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vue.component('settings-drawer', {
//   props: ['options', 'state']
// })
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings-drawer',
  props: ['options', 'state', 'roadmap'],
  data: function data() {
    return {
      urlTooltipText: "URL Copied!",
      urlTooltipVisible: false,
      urlTooltipColor: "green"
    };
  },
  methods: {
    share: function share() {
      var state = localStorage.getItem("roadmap");
      var hash = "#" + encodeURIComponent(state);

      if (history.pushState) {
        history.pushState(null, null, hash);
      } else {
        window.location.hash = hash;
      }

      copyToClipboard(window.location.href);

      // check for max length
      if (window.location.href.length > 2000) {
        this.urlTooltipText = "URL length too long";
        this.urlTooltipColor = "red";
      } else {
        this.urlTooltipText = "URL Copied!";
        this.urlTooltipColor = "green";
      }

      // show tooltip
      var self = this;
      self.urlTooltipVisible = true;
      // close on delay
      setTimeout(function () {
        self.urlTooltipVisible = false;
      }, 2000);
    },

    exportFile: function exportFile() {
      var jsonString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.roadmap, undefined, 2);

      var link = document.createElement('a');
      link.download = 'data.json';
      var blob = new Blob([jsonString], { type: 'text/plain' });
      link.href = window.URL.createObjectURL(blob);
      link.click();
    },

    importFile: function importFile(e) {
      var self = this;
      parseFile(e, function (obj) {
        self.$emit('update:roadmap', obj);
        // self.mutableRoadmap = obj
      });
    }

  }
});

function copyToClipboard(str) {
  var el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

function parseFile(event, callback) {
  var reader = new FileReader();
  var input = event.target;

  // add handler
  reader.onload = function (event) {
    var obj = JSON.parse(event.target.result);
    console.log(obj);
    // clear input
    input.value = "";
    callback(obj);
  };

  reader.readAsText(input.files[0]);
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "roadmap",
  props: ["options", "roadmap"],
  data: function data() {
    return {
      mounted: false
    };
  },
  methods: {
    updateFeatureName: function updateFeatureName(ft, $event) {
      ft.name = event.target.innerHTML.trim();
    },
    updateGroupName: function updateGroupName(grp, $event) {
      grp.groupName = event.target.innerHTML.trim();
    },

    addFeature: function addFeature(grp) {
      grp.features.push({ name: "", size: 2, completed: false });
    },
    removeFeature: function removeFeature(grp, index) {
      this.$delete(grp.features, index);
    },

    addGroup: function addGroup() {
      this.roadmap.push({ groupName: "", features: [] });
    },

    removeGroup: function removeGroup(grp, index) {
      this.$delete(this.roadmap, index);
    }

  },

  mounted: function mounted() {
    this.mounted = true;
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_free_css_all_css__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_free_css_all_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome_free_css_all_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_typeface_roboto_index_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_typeface_roboto_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_typeface_roboto_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_icons_iconfont_material_icons_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_settings_drawer__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_roadmap__ = __webpack_require__(25);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('settings-drawer', __WEBPACK_IMPORTED_MODULE_7__components_settings_drawer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('roadmap', __WEBPACK_IMPORTED_MODULE_8__components_roadmap__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    getVelocity: function getVelocity(shirtSize, velocities) {
      var v = velocities.find(function (v) {
        return v.value === shirtSize;
      });
      return v;
    },

    getSprints: function getSprints(features, velocities) {
      var self = this;
      var points = features.map(function (ft) {
        var v = self.getVelocity(ft.size, velocities);
        if (v === undefined) {
          console.error("sprints is null");
          return 0;
        }
        return +v.sprints;
      });
      var sum = points.reduce(function (acc, val) {
        return acc + val;
      }, 0);

      return sum;
    },

    getSprintTime: function getSprintTime(sprints, sprintLength) {
      return Math.round(sprints * sprintLength) + " wks";
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', {
  bind: function bind(el, binding) {
    if (binding.value === false) return;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
      var input = el.parentElement.querySelector('input,[contenteditable]');
      if (input) {
        input.focus();
        // input.select()
      }
    });
  }
});

/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eed9d250_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(14);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eed9d250_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('settings-drawer',{attrs:{"options":_vm.options,"state":_vm.state,"roadmap":_vm.roadmap},on:{"update:roadmap":function($event){_vm.roadmap = $event}}}),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","fixed":""}},[(!_vm.state.drawerOpen)?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.state.drawerOpen = !_vm.state.drawerOpen}}}):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(15),"alt":"Agile Roadmap","height":"40"}}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"headline ml-1"},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v("Agile")]),_vm._v(" Roadmap\n    ")]),_vm._v(" "),_c('div',{staticClass:"subheading pa-0 ml-2 hidden-md-and-up",staticStyle:{"line-height":"1.2"}},[_c('div',{staticClass:"green--text text--darken-2"},[_vm._v("\n          "+_vm._s(_vm._f("shortTimespan")(_vm.getSprints(_vm.completedFeatures, _vm.options.velocities) * _vm.options.sprintLength))+" done\n      ")]),_vm._v(" "),_c('div',{staticClass:"grey--text text--darken-2"},[_vm._v("\n          "+_vm._s(_vm._f("shortTimespan")(_vm.getSprints(_vm.remainingFeatures, _vm.options.velocities) * _vm.options.sprintLength))+" left\n      ")])]),_vm._v(" "),_c('div',{staticClass:"subheading pa-1 ml-3 hidden-sm-and-down",staticStyle:{"line-height":"1.2"}},[_c('div',{staticClass:"green--text text--darken-2"},[_vm._v("\n          "+_vm._s(_vm._f("timespan")(_vm.getSprints(_vm.completedFeatures, _vm.options.velocities) * _vm.options.sprintLength))+" completed\n      ")]),_vm._v(" "),_c('div',{staticClass:"grey--text text--darken-2"},[_vm._v("\n          "+_vm._s(_vm._f("timespan")(_vm.getSprints(_vm.remainingFeatures, _vm.options.velocities) * _vm.options.sprintLength))+" remaining\n      ")])]),_vm._v(" "),_c('v-progress-circular',{staticClass:"ml-3",attrs:{"value":_vm.progress,"size":"38","width":8,"rotate":180,"color":"green darken-1"}})],1),_vm._v(" "),_c('v-content',[_c('roadmap',{attrs:{"options":_vm.options,"roadmap":_vm.roadmap}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_drawer_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a25e3fd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_drawer_vue__ = __webpack_require__(24);
function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a25e3fd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a25e3fd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_drawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"mobile-break-point":"900","fixed":"","app":"","touchless":""},model:{value:(_vm.state.drawerOpen),callback:function ($$v) {_vm.$set(_vm.state, "drawerOpen", $$v)},expression:"state.drawerOpen"}},[_c('v-toolbar',{attrs:{"color":"green darken-2","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.state.drawerOpen = !_vm.state.drawerOpen}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Settings")])],1),_vm._v(" "),_c('v-list',[_c('v-subheader',[_vm._v("Options")]),_vm._v(" "),_c('v-list-group',{attrs:{"color":"green darken-4"},model:{value:(_vm.state.velocityOpen),callback:function ($$v) {_vm.$set(_vm.state, "velocityOpen", $$v)},expression:"state.velocityOpen"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-3"}},[_vm._v("fas fa-tachometer-alt")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(" Velocity")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Map shirt size to sprints")])],1)],1),_vm._v(" "),_c('v-subheader',[_vm._v("Sprint Length (# Wks)")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"large":"","color":"green darken-2"}},[_vm._v("fas fa-calendar-week")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"width":"70px"},attrs:{"shrink":""}},[_c('v-text-field',{staticClass:"mr-1 ml-0 mt-0 text--center-input",attrs:{"hide-details":"","single-line":"","min":"0","max":"5","step":".5","type":"number"},model:{value:(_vm.options.sprintLength),callback:function ($$v) {_vm.$set(_vm.options, "sprintLength", $$v)},expression:"options.sprintLength"}})],1),_vm._v(" "),_c('v-flex',[_c('v-slider',{attrs:{"min":0,"max":5,"step":".5","thumb-label":"","thumb-size":"28","ticks":"","color":"green darken-3"},model:{value:(_vm.options.sprintLength),callback:function ($$v) {_vm.$set(_vm.options, "sprintLength", $$v)},expression:"options.sprintLength"}})],1)],1)],1)],1),_vm._v(" "),_c('v-subheader',[_vm._v("Shirt Size (# Sprints)")]),_vm._v(" "),_vm._l((_vm.options.velocities),function(vel){return _c('v-list-tile',{key:vel.size},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"large":"","color":"green darken-2"}},[_vm._v("fas fa-tshirt")]),_vm._v(" "),_c('span',{staticClass:"icon-text"},[_vm._v(_vm._s(vel.shirt))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"width":"70px"},attrs:{"shrink":""}},[_c('v-text-field',{staticClass:"mr-1 ml-0 mt-0 text--center-input",attrs:{"hide-details":"","single-line":"","min":"0","max":"5","step":".5","type":"number"},model:{value:(vel.sprints),callback:function ($$v) {_vm.$set(vel, "sprints", $$v)},expression:"vel.sprints"}})],1),_vm._v(" "),_c('v-flex',[_c('v-slider',{attrs:{"min":0,"max":5,"step":".5","thumb-label":"","thumb-size":"28","ticks":"","color":"green darken-3"},model:{value:(vel.sprints),callback:function ($$v) {_vm.$set(vel, "sprints", $$v)},expression:"vel.sprints"}})],1)],1)],1)],1)})],2),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"color":"green darken-3"},model:{value:(_vm.options.sizeCardWidth),callback:function ($$v) {_vm.$set(_vm.options, "sizeCardWidth", $$v)},expression:"options.sizeCardWidth"}})],1),_vm._v(" "),_c('v-list-tile-content',{on:{"click":function($event){$event.preventDefault();_vm.options.sizeCardWidth = !_vm.options.sizeCardWidth}}},[_c('v-list-tile-title',[_vm._v("Card Width")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Size according to shirt size")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',[_vm._v("Export / Import")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-3"}},[_vm._v("fas fa-share-alt")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-tooltip',{attrs:{"nudge-bottom":"33px","nudge-right":"105px","color":_vm.urlTooltipColor,"attach":"#copy-url-btn"},model:{value:(_vm.urlTooltipVisible),callback:function ($$v) {_vm.urlTooltipVisible=$$v},expression:"urlTooltipVisible"}},[_c('span',[_vm._v(_vm._s(_vm.urlTooltipText))])]),_vm._v(" "),_c('v-btn',{staticClass:"white--text mx-0",attrs:{"id":"copy-url-btn","block":"","outline":"","color":"green darken-4","dark":""},on:{"click":_vm.share}},[_vm._v("\n                Share Via URL\n                ")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-3"}},[_vm._v("fas fa-file-export")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-btn',{staticClass:"white--text mx-0",attrs:{"block":"","outline":"","color":"green darken-4","dark":""},on:{"click":_vm.exportFile}},[_vm._v("\n                Export File\n                ")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"green darken-3"}},[_vm._v("fas fa-file-import")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-btn',{staticClass:"white--text mx-0",attrs:{"block":"","outline":"","color":"green darken-4","dark":""}},[_c('label',{staticClass:"custom-file-upload"},[_c('input',{ref:"fileUpload",staticStyle:{"display":"none"},attrs:{"type":"file","id":"file-upload"},on:{"change":function($event){_vm.importFile($event)}}}),_vm._v("\n                    Import File\n                                ")])])],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"justify-center pl-0",attrs:{"color":"light-green lighten-4","inset":"","app":""}},[_c('span',[_c('a',{attrs:{"href":"https://github.com/KyleMit/AgileRoadmap"}},[_c('i',{staticClass:"fab fa-github"}),_vm._v("\n              KyleMit\n            ")]),_vm._v("\n            © 2018")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roadmap_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a8736e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roadmap_vue__ = __webpack_require__(27);
function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roadmap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a8736e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roadmap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"overflow-x":"auto"},attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-layout',{attrs:{"align-start":"","justify-start":"","row":"","grid-list-4":""}},[_vm._l((_vm.roadmap),function(grp,grp_i){return _c('v-flex',{key:(grp_i + "-" + (grp.groupName)),attrs:{"shrink":""}},[_c('v-layout',{attrs:{"align-start":"","justify-start":"","column":"","fill-height":""}},[_c('v-card',{staticClass:"ma-1",attrs:{"width":"200","flat":"","color":"amber lighten-4"}},[_c('v-card-title',{staticClass:"pa-2 d-flex justify-center align-center ",attrs:{"primary-title":""}},[_c('div',[_c('div',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.mounted),expression:"mounted"}],staticClass:"display-1 ma-0 pa-1 reveal-input-hover",attrs:{"contenteditable":"true","placeholder":"Group"},domProps:{"innerHTML":_vm._s(grp.groupName)},on:{"blur":function($event){_vm.updateGroupName(grp, $event)}}}),_vm._v(" "),_c('div',{staticClass:"subheading pa-1 grey--text text--darken-2 "},[_vm._v("\n                    "+_vm._s(_vm.getSprints(grp.features, _vm.options.velocities))+" sprints\n                    ("+_vm._s(_vm.getSprintTime(_vm.getSprints(grp.features, _vm.options.velocities), _vm.options.sprintLength))+")\n                    ")])])])],1),_vm._v(" "),_vm._l((grp.features),function(ft,ft_i){return _c('v-hover',{key:(ft_i + "-" + (ft.name)),scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"ma-1",attrs:{"width":"200","hover":""}},[_c('v-card-title',{staticClass:"pa-2 d-flex justify-center align-center text--center",attrs:{"primary-title":""}},[_c('div',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.mounted),expression:"mounted"}],staticClass:"headline ma-0 pa-1 reveal-input-hover",attrs:{"contenteditable":"true","placeholder":"New Feature"},domProps:{"innerHTML":_vm._s(ft.name)},on:{"blur":function($event){_vm.updateFeatureName(ft, $event)}}})]),_vm._v(" "),_c('v-tooltip',{staticStyle:{"position":"absolute","top":"-6px","left":"-8px"},attrs:{"right":"","color":"deep-orange darken-4","nudge-bottom":"1px","nudge-left":"6px"}},[(hover)?_c('v-btn',{attrs:{"slot":"activator","color":"deep-orange darken-3","flat":"","icon":"","small":""},on:{"click":function($event){_vm.removeFeature(grp, ft_i)}},slot:"activator"},[_c('v-icon',{staticStyle:{"font-size":"1.3rem"}},[_vm._v("fas fa-trash-alt")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Remove Feature")])],1),_vm._v(" "),_c('v-tooltip',{staticStyle:{"position":"absolute","top":"-20px","right":"-9px"},attrs:{"left":"","color":"green darken-2","nudge-top":"6px","nudge-right":"6Spx"}},[(hover || ft.completed)?_c('v-checkbox',{attrs:{"slot":"activator","color":"green darken-3"},slot:"activator",model:{value:(ft.completed),callback:function ($$v) {_vm.$set(ft, "completed", $$v)},expression:"ft.completed"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Mark Complete")])],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-0"},[_c('v-rating',{attrs:{"empty-icon":'fas fa-tshirt',"full-icon":'fas fa-tshirt',"hover":"","dense":"","color":"green darken-2","background-color":"grey lighten-3"},model:{value:(ft.size),callback:function ($$v) {_vm.$set(ft, "size", $$v)},expression:"ft.size"}})],1)],1)}}])})}),_vm._v(" "),_c('v-card',{staticClass:"d-flex flex-row",attrs:{"flat":"","tile":""}},[_c('v-tooltip',{attrs:{"right":"","color":"green darken-2"}},[_c('v-btn',{attrs:{"slot":"activator","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){_vm.addFeature(grp)}},slot:"activator"},[_c('v-icon',[_vm._v("fa fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Feature")])],1),_vm._v(" "),(grp.features.length === 0)?_c('v-tooltip',{attrs:{"right":"","color":"deep-orange darken-4"}},[_c('v-btn',{attrs:{"slot":"activator","color":"deep-orange darken-3 ","fab":"","dark":"","small":""},on:{"click":function($event){_vm.removeGroup(grp, grp_i)}},slot:"activator"},[_c('v-icon',[_vm._v("fa  fa-trash-alt")])],1),_vm._v(" "),_c('span',[_vm._v("Remove Group")])],1):_vm._e()],1)],2)],1)}),_vm._v(" "),_c('v-tooltip',{attrs:{"right":"","color":"green darken-2"}},[_c('v-btn',{attrs:{"slot":"activator","color":"green ","fab":"","dark":"","small":""},on:{"click":function($event){_vm.addGroup()}},slot:"activator"},[_c('v-icon',[_vm._v("fa fa-plus")])],1),_vm._v(" "),_c('span',[_vm._v("Add Group")])],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[7]);


// WEBPACK FOOTER //
// static/js/app.d5c500d327421ef3202e.js